import { LeaseItem } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const getApplicationItems = async (context: any): Promise<LeaseItem[] | undefined> => {
  try {
    const result = await applicationFormService.getApplicationItems(context.application?.lease?.id);

    return result?.data?.getLeaseApplicationItems.items ?? [];
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};
export default getApplicationItems;
